import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { Button, Card, CardBody, CardTitle, Col, Input, Modal, Row, Table } from "reactstrap";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import SupplyDemandPlan from "./SupplyDemandPlan/SupplyDemandPlan";
import moment from "moment";

function SectionTodayGasPlan(props) {
    return (

        <Row>
            <Col sm="12">
                <Card  className="mb-1" style={{ backgroundColor: "#0087ff1a" }}>
                    <CardBody>
                        <Row>
                            <Col sm="12">
                                <Row className="mt-0">
                                    <Col sm="12">
                                        <h5 className="mb-0 sm-0 font-size-18" style={{ color: "#46FCFF" }}>Today Gas Plan And Activity Summary</h5>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <hr style={{ color: "#46FCFF" }} />
                                </Row>

                                <Row className="mt-0">
                                    <Col lg="12">
                                    
                                        <SupplyDemandPlan date={props.date} summaryReportPid={props.summaryReportPid} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>

    )
}

SectionTodayGasPlan.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid:PropTypes.any
}

export default SectionTodayGasPlan
